module.exports = ".login-background {\n  background-image: url('bk-side2.5408ee8bfb555d5c4851.jpg'); }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.scss
// module id = ./src/app/app.component.scss
// module chunks = main